const section = document.querySelector('.portfolio-page')
const posts = section.querySelector('.posts')
let loading = false

const params = new URLSearchParams(window.location.search)
const slug = params.get('category')
let selectedCategoryId = null

if (slug && slug !== 'all' && window.portfolioCategories) {
    const categories = Array.isArray(window.portfolioCategories)
        ? window.portfolioCategories
        : Object.values(window.portfolioCategories)

    const match = categories.find(cat => cat.slug === slug)

    if (match) {
        selectedCategoryId = match.term_id
    }
}
async function fetchMorePortfolioItems() {
	const hasIds = Array.from(posts.querySelectorAll('.tease-portfolio'))
		.map(item => parseInt(item.dataset.id, 10))
		.filter(id => Number.isInteger(id))
		.join(',')

	console.log('hasIds', hasIds)

	let url = `/wp-json/wp/v2/portfolio?per_page=9&_embed&exclude=${hasIds}`
	
	if (selectedCategoryId){
		url += `&categories=${selectedCategoryId}`
	}
	const res = await fetch(
		url
	)
	let data = await res.json()
    
	const elementsToAdd = data.map(createPortfolioItem)
    console.log(elementsToAdd)

	posts.append(...elementsToAdd)

	loading = false

	// do this later
	// console.log(res.headers)
	// if ((headers == 0)) {
	// 	obs.disconnect(0)
	// }
}

const portfolioItemTemplate = document.querySelector('#portfolio-item-template')

function createPortfolioItem(item) {
	const featuredMedia =
		item._embedded?.['wp:featuredmedia']?.[0] || null

	const frag = portfolioItemTemplate.content.cloneNode(true)
	const portfolioItem = frag.querySelector('.tease-portfolio')
    const linkHolder = frag.querySelector('.tease-portfolio a')
	const projectTitle = frag.querySelector('.heading')

	projectTitle.innerHTML = item.title.rendered

	linkHolder.href = item.link
	portfolioItem.dataset.id = item.id
	// projectTitle.insertBefore(titleHolder, projectTitle.children[0])

	const img = frag.querySelector('img')

	if (featuredMedia && featuredMedia.media_details?.sizes) {
		img.src = featuredMedia.source_url
		img.srcset = buildSrcset(featuredMedia.media_details.sizes)
		img.alt = featuredMedia.alt_text
	} else {
		// No featured image → fallback
		img.src = '/wp-content/uploads/default.jpg'
		img.srcset = ''
		img.alt = item.title.rendered
	}

	return frag
}


function buildSrcset(sizes) {
	console.log('createPobuildSrcsetrtfolioItem', sizes)
	return Object.values(sizes)
		.map(size => `${size.source_url} ${size.width}w`)
		.join(', ')
}

const obs = new IntersectionObserver(entries => {
	if (entries[0].isIntersecting && !loading) {
		loading = true
		fetchMorePortfolioItems()
	}
})

obs.observe(document.querySelector('#footer'))